/**
 * Product card utilities
 *
 * @module utils/product-cards
 */

/**
 * Announce that product cards were added to the page.
 *
 * Filtering, sorting, load more and infinite scroll drop plain markup into the
 * grid, so anything bound to a card on page load - the hover video handlers - is
 * never bound to those cards. Everything that injects cards calls this so that
 * behaviour is applied to them too.
 *
 * @param {object} container Element the new cards live in.
 * @returns {undefined}
 */
export function notifyProductCardsLoaded(container) {

    document.dispatchEvent(new CustomEvent('product-cards:loaded', {
        detail: { container: container || document }
    }));
}
